import { observer } from 'mobx-react-lite';

import { Icons } from '@/assets/icons/icons';
import { Tooltip } from '@/components/ui';
import { cn } from '@/lib/utils';
import { userStore } from '@/stores/user.store';

type HiddenFromUserIconProps = {
  hidden: boolean;
  className?: string;
};

/** Marks a routine or chat the API keeps from the user; only internal users see it. */
const HiddenFromUserIcon = observer(
  ({ hidden, className }: HiddenFromUserIconProps) => {
    if (!hidden || !userStore.isInternalUser) return null;

    return (
      <Tooltip label="Hidden from the user. You see it because you are internal.">
        <span className="inline-flex shrink-0 items-center">
          <Icons.eyeOff
            aria-label="Hidden from the user"
            className={cn('size-3.5 text-foreground-muted', className)}
          />
        </span>
      </Tooltip>
    );
  }
);

export { HiddenFromUserIcon };
